import { render, staticRenderFns } from "./addGood_1.vue?vue&type=template&id=3dea2754&scoped=true"
import script from "./addGood_1.vue?vue&type=script&lang=js"
export * from "./addGood_1.vue?vue&type=script&lang=js"
import style0 from "./addGood_1.vue?vue&type=style&index=0&id=3dea2754&prod&lang=stylus&scoped=true"
import style1 from "./addGood_1.vue?vue&type=style&index=1&id=3dea2754&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dea2754",
  null
  
)

export default component.exports